module.exports = __webpack_public_path__ + "static/media/alfie_light.6dcc63b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/AdminMapView/alfie_light.png
// module id = 816
// module chunks = 0